(() => {
  'use strict';

  const CART_OPEN_CLASS = 'cart-drawer-open';
  const MENU_OPEN_CLASS = 'menu-drawer-open';
  const CHAT_SELECTOR = 'shopify-chat';

  function hideChat(chat) {
    chat.style.setProperty('display', 'none', 'important');
    chat.style.setProperty('visibility', 'hidden', 'important');
    chat.style.setProperty('opacity', '0', 'important');
    chat.style.setProperty('pointer-events', 'none', 'important');
  }

  function showChat(chat) {
    chat.style.removeProperty('display');
    chat.style.removeProperty('visibility');
    chat.style.removeProperty('opacity');
    chat.style.removeProperty('pointer-events');
  }

  function shouldHideChat() {
    const cartOpen =
      document.body.classList.contains(CART_OPEN_CLASS);

    const menuOpen =
      document.documentElement.classList.contains(MENU_OPEN_CLASS);

    return cartOpen || menuOpen;
  }

  function syncShopifyChat() {
    const hide = shouldHideChat();

    document.querySelectorAll(CHAT_SELECTOR).forEach((chat) => {
      if (hide) {
        hideChat(chat);
      } else {
        showChat(chat);
      }
    });
  }

  function init() {
    if (!document.body) return;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class' &&
          (
            mutation.target === document.body ||
            mutation.target === document.documentElement
          )
        ) {
          syncShopifyChat();
          return;
        }

        if (mutation.type === 'childList') {
          syncShopifyChat();
          return;
        }
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });

    window.addEventListener('pageshow', syncShopifyChat);

    syncShopifyChat();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();